import { Col } from '@opendoor/atoms/box';
import type { PropertyDetailsFragment } from '__generated__/athena/graphql';
import { Divider } from 'components/shared/Divider';

import { HomeDetails } from '../HomeDetails';
import { PriceHistory } from '../PriceHistory';
import { Schools } from '../Schools';

interface PropertyDetailsProps {
  property: PropertyDetailsFragment;
}

export const PropertyDetails = ({ property }: PropertyDetailsProps) => {
  return (
    <>
      <Col as="section">
        <HomeDetails property={property} />
        <Divider className="py-4" />
      </Col>
      <Col as="section">
        <Schools schools={property?.schools} schoolDistricts={property?.schoolDistricts} />
        <Divider className="py-4" />
      </Col>
      <Col as="section">
        {property?.listingHistory && <PriceHistory listingHistory={property.listingHistory} />}
        <Divider className="pt-4 pb-10" />
      </Col>
    </>
  );
};
